import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Instagram } from 'lucide-react';
interface SponsorsSectionProps {
  variant?: 'light' | 'cream';
}
export function SponsorsSection({
  variant = 'light'
}: SponsorsSectionProps) {
  const sponsors = [{
    name: 'Dra. Ysailis Martinez',
    specialty: 'Obstetricia & Ginecología',
    instagram: '@draysailismartinez',
    instagramUrl: 'https://instagram.com/draysailismartinez',
    logo: 'https://cdn.magicpatterns.com/uploads/okgRdBBQJzKcSRtD9qMESP/logo_Dra_Ysalismar.png'
  }, {
    name: 'Centro Médico Especializado Profem',
    specialty: 'Atención Materno-Infantil',
    instagram: '@profemm.ccs',
    instagramUrl: 'https://instagram.com/profemm.ccs',
    logo: 'https://cdn.magicpatterns.com/uploads/iK55MfTG9wGEtTuc3hbtvX/Logo_Centro_medico_Especializado_Profem.jpg'
  }];
  const bgClass = variant === 'cream' ? 'bg-cream-dark/30' : 'bg-white';
  return <section className={`py-16 md:py-20 ${bgClass}`} data-id="element-279">
      <div className="max-w-5xl mx-auto px-6" data-id="element-280">
        <FadeIn data-id="element-281">
          <div className="text-center mb-10" data-id="element-282">
            <p className="text-sm font-bold text-accent uppercase tracking-widest mb-3" data-id="element-283">
              Con el respaldo profesional de
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-brown-dark" data-id="element-284">
              Profesionales que avalan este método
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-285">
          {sponsors.map((sponsor, index) => <FadeIn key={sponsor.name} delay={index * 0.15} data-id="element-286">
              <div className="bg-white rounded-3xl p-6 md:p-8 border-2 border-cream-dark hover:border-accent/40 transition-all duration-300 shadow-sm hover:shadow-soft h-full" data-id="element-287">
                <div className="flex flex-col items-center text-center" data-id="element-288">
                  {/* Logo */}
                  <div className="w-32 h-32 md:w-40 md:h-40 flex items-center justify-center mb-5 bg-white rounded-2xl" data-id="element-289">
                    <img src={sponsor.logo} alt={`Logo ${sponsor.name}`} className="max-w-full max-h-full object-contain" data-id="element-290" />
                  </div>

                  {/* Name */}
                  <h3 className="text-lg md:text-xl font-bold text-brown-dark mb-1" data-id="element-291">
                    {sponsor.name}
                  </h3>

                  {/* Specialty */}
                  <p className="text-sm text-brown/70 font-serif italic mb-4" data-id="element-292">
                    {sponsor.specialty}
                  </p>

                  {/* Instagram link */}
                  <a href={sponsor.instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-accent font-semibold text-sm hover:text-brown-dark transition-colors duration-200" data-id="element-293">
                    <Instagram className="w-4 h-4" data-id="element-294" />
                    <span data-id="element-295">{sponsor.instagram}</span>
                  </a>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}